// This is generated.  Alter it in blockGroups/searchElements/types/ToggleSearch.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      propertyName,
      toggleValues,
      neutralOption,
      includeUndefinedAsFalse,
    } = hNode;
    const subDataDictionary = {};

    // Create TypeBox boolean schema with toggle-specific metadata
    const booleanSchema = Type.Boolean({
      'x-id': id,
      title: title,
      'x-dataType': 'boolean',
      'x-propertyName': propertyName,
      'x-toggleValues': toggleValues,
      'x-neutralOption': neutralOption,
      'x-includeUndefinedAsFalse': includeUndefinedAsFalse,
    });

    const partialTypeDefinition = {
      [propertyName]: booleanSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'searchElements',
  'ToggleSearch',
  module.exports,
);
